import spinner from '@/directives/spinner';

export default {
  spinner
};


// WEBPACK FOOTER //
// ./src/directives/directives.js